(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artsy-artwork-strip"] && !Shopify.designMode) return;
  try {
    
  const artworkStripPools = new WeakMap();
  const artworkStripKey = (artwork) => new URL(artwork.href).pathname.split('/').filter(Boolean).pop();

  const initializeArtworkStrips = () => {
    const carousel = document.querySelector('.selected-works__carousel');
    if (carousel && !carousel.dataset.selectionDay && !window.Shopify?.designMode) return;
    const day = Number(carousel?.dataset.selectionDay) || 0;
    // Reserve today's full selection, including slides that are currently off screen.
    const selectedWorks = new Set([...document.querySelectorAll('.selected-works__image')].map(artworkStripKey));
    const selectedSignature = `${day}|${[...selectedWorks].sort().join('|')}`;

    document.querySelectorAll('.artsy-artwork-strip').forEach((strip) => {
      if (strip.dataset.initialized === 'true' && strip.dataset.selectedWorks === selectedSignature) return;

      const groups = strip.querySelectorAll('.artsy-artwork-strip__group');
      if (groups.length !== 2) return;

      const primaryGroup = groups[0];
      const duplicateGroup = groups[1];
      const originalPool = artworkStripPools.get(strip) || {
        artworks: Array.from(primaryGroup.querySelectorAll('.artsy-artwork-strip__artwork')),
        copies: Array.from(duplicateGroup.querySelectorAll('.artsy-artwork-strip__artwork')),
      };
      artworkStripPools.set(strip, originalPool);
      const artworkPool = originalPool.artworks.filter((artwork) => !selectedWorks.has(artworkStripKey(artwork)));
      const selectionSize = Math.min(Number(strip.dataset.selectionSize) || 10, artworkPool.length);
      strip.style.setProperty('--artsy-strip-duration', `${Math.max(22, selectionSize * 2.2)}s`);

      const offset = artworkPool.length ? (day * selectionSize) % artworkPool.length : 0;
      const selection = artworkPool.slice(offset).concat(artworkPool.slice(0, offset)).slice(0, selectionSize);

      primaryGroup.querySelectorAll('.artsy-artwork-strip__artwork').forEach((artwork) => artwork.remove());
      duplicateGroup.querySelectorAll('.artsy-artwork-strip__artwork').forEach((artwork) => artwork.remove());

      selection.forEach((artwork) => primaryGroup.append(artwork));
      selection.forEach((artwork) => {
        // Reuse both copies so their image-recovery listeners survive a daily change.
        const duplicate = originalPool.copies[originalPool.artworks.indexOf(artwork)];
        duplicate.removeAttribute('data-shopify-editor-block');
        duplicate.setAttribute('tabindex', '-1');
        duplicateGroup.append(duplicate);
      });

      strip.dataset.initialized = 'true';
      strip.dataset.selectedWorks = selectedSignature;
    });
  };

  initializeArtworkStrips();
  document.addEventListener('shopify:section:load', initializeArtworkStrips);
  document.addEventListener('selected-works:change', initializeArtworkStrips);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-notice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('payment-notice')) {
    customElements.define('payment-notice', class extends HTMLElement {
      connectedCallback() {
        this.observer = new ResizeObserver(() => {
          document.body.style.setProperty('--payment-notice-height', this.offsetHeight + 'px');
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.body.style.removeProperty('--payment-notice-height');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activeControllers = new Map();

    const teardownController = (sectionId) => {
      const controller = activeControllers.get(sectionId);
      if (! controller) return;
      


      if (controller.intervalId) 
        clearInterval(controller.intervalId);
      


      if (controller.parallaxFrame) 
        cancelAnimationFrame(controller.parallaxFrame);
      


      if (controller.motesFrame) 
        cancelAnimationFrame(controller.motesFrame);
      


      if (controller.onResize) 
        window.removeEventListener('resize', controller.onResize);
      


      if (controller.cleanupMove) 
        controller.cleanupMove();
      


      activeControllers.delete(sectionId);
    };

    const initRotatingHero = (root) => {
      if (!(root instanceof HTMLElement)) return;
      


      const sectionId = root.dataset.sectionId;
      if (! sectionId) return;
      


      teardownController(sectionId);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const scenes = Array.from(root.querySelectorAll('[data-scene]'));
      if (scenes.length === 0) return;
      


      const rig = root.querySelector('[data-rig]');
      const motesCanvas = root.querySelector('[data-motes-canvas]');
      const holdMsRaw = Number.parseFloat(root.dataset.holdMs || '8000');
      const holdMs = Number.isFinite(holdMsRaw)
        ? Math.max(holdMsRaw, 50)
        : 8000;
      const enableParallax = root.dataset.enableParallax === 'true';
      const enableMotes = root.dataset.enableMotes === 'true';

      let current = 0;
      let activeColors = [];
      let intervalId;

      const setActiveScene = (nextIndex) => {
        scenes[current].classList.remove('is-active');
        current = nextIndex;
        scenes[current].classList.add('is-active');

        const bg = scenes[current].dataset.bg;
        if (bg) {
          root.style.background = bg;
        }

        const colors = scenes[current].dataset.colors || '';
        activeColors = colors.split('|').filter(Boolean);
      };

      const initialBg = scenes[0].dataset.bg;
      if (initialBg) 
        root.style.background = initialBg;
      


      activeColors = (scenes[0].dataset.colors || '').split('|').filter(Boolean);

      if (! reducedMotion && scenes.length > 1) {
        intervalId = window.setInterval(() => {
          const next = (current + 1) % scenes.length;
          setActiveScene(next);
        }, holdMs);
      }

      let parallaxFrame;
      let motesFrame;
      let pointerX = 0;
      let pointerY = 0;
      let currentX = 0;
      let currentY = 0;

      if (! reducedMotion && enableParallax && window.matchMedia('(pointer: fine)').matches && rig instanceof HTMLElement) {
        const onMove = (event) => {
          pointerX = (event.clientX / window.innerWidth - 0.5) * -14;
          pointerY = (event.clientY / window.innerHeight - 0.5) * -10;
        };

        root.addEventListener('mousemove', onMove);

        const parallaxTick = () => {
          currentX += (pointerX - currentX) * 0.04;
          currentY += (pointerY - currentY) * 0.04;
          rig.style.transform = `translate(${
            currentX.toFixed(2)
          }px, ${
            currentY.toFixed(2)
          }px)`;
          parallaxFrame = requestAnimationFrame(parallaxTick);
        };

        parallaxTick();

        const existing = activeControllers.get(sectionId) || {};
        existing.cleanupMove = () => root.removeEventListener('mousemove', onMove);
        activeControllers.set(sectionId, existing);
      }

      if (! reducedMotion && enableMotes && motesCanvas instanceof HTMLCanvasElement) {
        const ctx = motesCanvas.getContext('2d');
        if (ctx) {
          const motes = [];
          let width = 0;
          let height = 0;

          const resizeCanvas = () => {
            const ratio = window.devicePixelRatio || 1;
            const bounds = root.getBoundingClientRect();
            width = Math.max(bounds.width, 1) * ratio;
            height = Math.max(bounds.height, 1) * ratio;
            motesCanvas.width = width;
            motesCanvas.height = height;
          };

          resizeCanvas();

          const count = Math.min(46, Math.round(window.innerWidth / 30));
          for (let i = 0; i < count; i += 1) {
            motes.push({
              x: Math.random(),
              y: Math.random(),
              r: 0.6 + Math.random() * 1.7,
              vx: (Math.random() - 0.5) * 0.00006,
              vy: -0.00003 - Math.random() * 0.00007,
              c: activeColors[i % Math.max(activeColors.length, 1)] || '#f3db9f',
              p: Math.random() * Math.PI * 2,
              ps: 0.2 + Math.random() * 0.5
            });
          }

          let last = performance.now();

          const motesTick = (now) => {
            const dt = Math.min(50, now - last);
            last = now;

            ctx.clearRect(0, 0, width, height);

            for (let i = 0; i < motes.length; i += 1) {
              const mote = motes[i];
                mote.x += mote.vx * dt;
                mote.y += mote.vy * dt;
                mote.p += (mote.ps * dt) / 1000;

                if (mote.y<-0.02) {
                mote.y = 1.02;
                mote.x = Math.random();
                mote.c = activeColors[i % Math.max(activeColors.length, 1)] || mote.c;
              }

              if (mote.x < -0.02) mote.x = 1.02;
              if (mote.x > 1.02) mote.x = -0.02;

              const alpha = 0.14 + 0.3 * (0.5 + 0.5 * Math.sin(mote.p));
              const px = (mote.x + (currentX / Math.max(window.innerWidth, 1)) * 2.4) * width;
              const py = (mote.y + (currentY / Math.max(window.innerHeight, 1)) * 2.4) * height;
              const radius = mote.r * (window.devicePixelRatio || 1);
              const gradient = ctx.createRadialGradient(px, py, 0, px, py, radius * 5);

              gradient.addColorStop(0, mote.c);
              gradient.addColorStop(1, 'transparent');

              ctx.globalAlpha = alpha;
              ctx.fillStyle = gradient;
              ctx.beginPath();
              ctx.arc(px, py, radius * 5, 0, Math.PI * 2);
              ctx.fill();
            }

            ctx.globalAlpha = 1;
            motesFrame = requestAnimationFrame(motesTick);
          };

          motesTick(last);

          const existing = activeControllers.get(sectionId) || {};
          existing.onResize = resizeCanvas;
          activeControllers.set(sectionId, existing);
          window.addEventListener('resize', resizeCanvas);
        }
      }

      const existing = activeControllers.get(sectionId) || {};
      existing.intervalId = intervalId;
      existing.parallaxFrame = parallaxFrame;
      existing.motesFrame = motesFrame;
      activeControllers.set(sectionId, existing);
    };

    const initFromContainer = (container) => {
                  if (!(container instanceof HTMLElement)) return;
                  


                  const root = container.querySelector('[data-rotating-hero]');
                  if (!(root instanceof HTMLElement)) return;
                  


                  initRotatingHero(root);
                };

                document.querySelectorAll('[data-rotating-hero]').forEach((root) => {
                  initRotatingHero(root);
                });

                document.addEventListener('shopify:section:load', (event) => {
                  initFromContainer(event.target);
                });

                document.addEventListener('shopify:section:unload', (event) => {
                  const target = event.target;
                  if (!(target instanceof HTMLElement)) return;
                  


                  const root = target.querySelector('[data-rotating-hero]');
                  if (!(root instanceof HTMLElement)) return;
                  


                  const sectionId = root.dataset.sectionId;
                  if (! sectionId) return;
                  


                  teardownController(sectionId);
                });
              }
            )();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-works"] && !Shopify.designMode) return;
  try {
    
  const selectedWorksOrders = new WeakMap();
  const selectedWorksDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  const rotateSelectedWorksDaily = () => {
    if (window.Shopify?.designMode || document.hidden) return;
    const parts = Object.fromEntries(selectedWorksDate.formatToParts(new Date()).map(({ type, value }) => [type, value]));
    const day = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000;

    let changed = false;
    document.querySelectorAll('.selected-works__carousel').forEach((slideshow) => {
      const slides = [...slideshow.querySelectorAll('.selected-works__slide')];
      let order = selectedWorksOrders.get(slideshow);
      if (!order) {
        order = { cards: slides.map((slide) => slide.firstElementChild), day: null };
        selectedWorksOrders.set(slideshow, order);
      }
      if (order.day === day) return;
      // Defer the midnight change while someone is interacting with the paintings.
      if (order.day !== null && (slideshow.matches(':hover') || slideshow.contains(document.activeElement) || document.querySelector('.artsy-artwork-strip:is(:hover, :focus-within)'))) return;
      const edition = String((day % 3) + 1);
      const selection = order.cards.filter((card) => (card.dataset.selectionDays || '1,2,3').split(',').includes(edition));
      const offset = selection.length ? ((Number(edition) - 1) * 3) % selection.length : 0;
      slides.forEach((slide, index) => {
        slide.hidden = index >= selection.length;
        slide.replaceChildren(...(slide.hidden ? [] : [selection[(index + offset) % selection.length]]));
      });
      slideshow.querySelectorAll('.selected-works__position').forEach((dot, index) => {
        dot.hidden = index >= selection.length;
      });
      slideshow.select?.(0, undefined, { animate: false });
      slideshow.dataset.selectionDay = String(day);
      order.day = day;
      changed = true;
    });
    if (changed) document.dispatchEvent(new CustomEvent('selected-works:change'));
  };
  rotateSelectedWorksDaily();
  setInterval(rotateSelectedWorksDaily, 60000);
  document.addEventListener('visibilitychange', rotateSelectedWorksDaily);
  document.addEventListener('shopify:section:load', rotateSelectedWorksDaily);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pauseSelectedWorks = () => {
    if (!reducedMotion.matches) return;
    document.querySelectorAll('.selected-works__carousel').forEach((slideshow) => slideshow.pause());
  };
  customElements.whenDefined('slideshow-component').then(pauseSelectedWorks);
  reducedMotion.addEventListener('change', pauseSelectedWorks);
  document.addEventListener('shopify:section:load', pauseSelectedWorks);
  document.addEventListener('focusin', (event) => {
    const slideshow = event.target.closest('.selected-works__carousel');
    if (slideshow && !event.target.closest('.selected-works__playback')) slideshow.pause();
  });

  } catch(e) { console.error(e); }
})();
})();
